import {Component, DoCheck, Input} from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-change-detection-logging',
  standalone: true,
  imports: [
    NgIf
  ],
  template: `
    <div *ngIf="visible">
      DoCheck: {{ counter }}
    </div>
  `,
  styles: ``
})
export class ChangeDetectionLoggingComponent implements DoCheck {
  counter: number = 0;

  @Input() toConsole: boolean = true;
  @Input() visible: boolean = true;

  ngDoCheck() {
    this.counter++;
    if (this.toConsole) {
      console.log(this.counter);
    }

  }
}
